// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__wQlBp","topContainer":"index_topContainer__1wuKf","collapseContent":"index_collapseContent__dziZB","infoContainer":"index_infoContainer__2djGu"};